// extracted by mini-css-extract-plugin
export default {"nameOfBankMenuOpen":"NameOfBank_nameOfBankMenuOpen__TvOxn"};